export const CART_POPOVER_ID = 'cart-slideout';
